export default __webpack_public_path__ + "static/media/icon-check.a8fb15d0.svg";